//Styles
import Styles from "./DefaultSettingsScreen.module.scss";

const DefaultSettingsScreen = () => {
  return (
    <div className={Styles.container}>
        <img className={Styles.pfp} src={"https://images.macrumors.com/t/n4CqVR2eujJL-GkUPhv1oao_PmI=/1600x/article-new/2019/04/guest-user-250x250.jpg"}/>
        <div className={Styles.info_text}>
            Some System Preferences are disabled for guest users. Available preferences are : 
            <div className={Styles.menu_items}>
                - Appearance<br/>
                - Display<br/>
                - Wallpaper<br/>
                - Screensaver<br/>
                - Dock & Menubar<br/>
            </div>
        </div>
    </div>
  )
}

export default DefaultSettingsScreen
